var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"components-edit-shape",class:{
    active: this.active,
    'element-on-edit-pane-hide': _vm.defaultStyle.display == 'none',
  },attrs:{"data-uuid":_vm.uuid},on:{"click":_vm.handleTopWrapperClick,"mousedown":_vm.handleMouseDownOnElement,"dblclick":_vm.handleDbClickOnElement}},[_vm._l((_vm.active ? _vm.pointList : []),function(item){return _c('div',{key:item,staticClass:"edit-shape-point",style:(_vm.getPointStyle(item)),on:{"mousedown":function($event){return _vm.handleMouseDownOnPoint(item)}}})}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }